import { useEffect, useState } from 'react';
import { AxiosError } from 'axios';
import { Navigate } from 'react-router-dom';
import {
  fetchCurrentCustomerSession,
  type CustomerSession,
} from './auth/customerSession';
import { clearCustomerAuthToken, saveCustomerAuthToken } from './auth/customerAuthToken';

const RequireAuth = ({ children }: { children: JSX.Element }) => {
  const [status, setStatus] = useState<'loading' | 'authorized' | 'unauthorized'>('loading');

  useEffect(() => {
    let active = true;

    const loadSession = async () => {
      try {
        const session: CustomerSession = await fetchCurrentCustomerSession();
        if (!active) return;

        localStorage.setItem('customerId', String(session.customer_id));
        localStorage.setItem('customerName', session.name);
        saveCustomerAuthToken(session.auth_token);
        setStatus('authorized');
      } catch (error) {
        if (!active) return;

        const axiosError = error as AxiosError;
        if (axiosError.response?.status === 401) {
          clearCustomerAuthToken();
          localStorage.removeItem('customerId');
          localStorage.removeItem('customerName');
          setStatus('unauthorized');
          return;
        }

        console.error('RequireAuth session load failed:', error);
        setStatus('unauthorized');
      }
    };

    void loadSession();

    return () => {
      active = false;
    };
  }, []);

  if (status === 'loading') {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[radial-gradient(circle_at_top,#e8f5f1_0%,#f8fafc_42%,#eef5f8_100%)] px-6">
        <div className="rounded-[24px] border border-slate-200 bg-white px-5 py-4 text-sm font-medium text-slate-500 shadow-sm">
          Checking your session...
        </div>
      </div>
    );
  }

  if (status === 'unauthorized') {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default RequireAuth;
